let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aS96v")).then(() => parcelRequire('79cvA'));